// slotPageFill.js — how a page mounted in a PageSlot host sizes
// (ANSWER-VIEW-CONTENT-SIZED-1).
//
// A page FILLS its host (height / min-height 100%) — except a CONTENT-SIZED
// page: an AI answer view, which canvas answerUi registers with
// `metadata.contentSized`. Measured on dev 2026-10-04 (Storm): forced to fill,
// an answer of three stat tiles drew three ~1000 px tiles, empty below the
// numbers. A content-sized page keeps its own height (the host scrolls).
export const slotPageFillProps = (def) =>
  def && def.metadata && def.metadata.contentSized === true
    ? { height: 'auto', minHeight: '0' }
    : { height: '100%', minHeight: '100%' }
